import { QueryColumn } from 'query/QueryColumn';
import React, { CSSProperties, MouseEventHandler } from 'react';
import './DataTable.css';
import MultipleQueryColumn, { OrderedBy } from 'query/MultipleQueryColumn';

// TODO If the size of the contents div changes:
//  https://www.pluralsight.com/guides/re-render-react-component-on-window-resize


export interface RowHeaderProps {
    column: QueryColumn;
    layout: CSSProperties;
    orderedBy: OrderedBy;
    onOrderBy: (c: QueryColumn, o: OrderedBy) => void;
    startResizeColumn: (ev: React.MouseEvent<HTMLDivElement>, column: QueryColumn) => void;
    columnsChanged: () => void;
    onContextMenu: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>, column: QueryColumn) => void;
}

export interface RowHeaderState {
    // I... have no state!?
}

// TODO: Rename to ColumnHeader.
export class RowHeader extends React.Component<RowHeaderProps, RowHeaderState> {
    public static readonly DragDataPrefix = "column-";

    constructor(props: Readonly<RowHeaderProps>) {
        super(props);
        this.state = {
            isExpanded: false,
            width: 100 // TODO: magic number
        };
        this.onExpandComplexColumn = this.onExpandComplexColumn.bind(this);
        this.onUnexpandComplexColumn = this.onUnexpandComplexColumn.bind(this);
    }

    /* Render one column heading. */
    public render = () => {
        let column: QueryColumn = this.props.column;
        let collapse: JSX.Element;
        if (column.canHaveChildren()) {
            if (column.isExpanded) {
                collapse = miniButton("datatable-expandbutton", "▼",
                    (e) => this.onUnexpandComplexColumn(e));
            } else {
                collapse = miniButton("datatable-expandbutton", "▶",
                    (e) => this.onExpandComplexColumn(e));
            }
        } else {
            collapse = <></>;
        }

        let xorderBy: JSX.Element;
        switch (this.props.orderedBy) {
            case OrderedBy.ASC:
                xorderBy = miniButton("datatable-sortbutton", "◢", (e) => {
                    this.props.onOrderBy(column, OrderedBy.DESC);
                });
                break;
            case OrderedBy.DESC:
                xorderBy = miniButton("datatable-sortbutton", "◥", (e) => {
                    this.props.onOrderBy(column, OrderedBy.NA);
                });
                break;
            default:
                xorderBy = miniButton("datatable-sortbutton", "", (e) => {
                    this.props.onOrderBy(column, OrderedBy.ASC);
                });
                break;
        }

        // We need to do this to make the absolute positioning of the resize grip work.
        // TODO - don't mutate props. This is causing stuff to crash.
        //this.props.layout['position'] = 'relative';

        return <div
            style={this.props.layout}>
            {/* We assume the first child here has data-columnName */}
            <div onContextMenu={this.onContextMenu}
                id={`heading_${column.name}`}
                className="datatable-head-cell"
                data-columnname={column.name}
                draggable={true}
                onDragStart={this.onHeadingDragStart}>
                {collapse}
                <span>{column.name}</span>
                {xorderBy}

            </div>

            {/* A mini div to drag-resize columns. */}
            <div style={{
                position: 'absolute',
                width: 6,
                height: '100%',
                right: 0,
                top: 0,
                cursor: 'ew-resize',
            }} onMouseDown={(ev) => this.props.startResizeColumn(ev, column)}>
            </div>
        </div>;
    }

    private onExpandComplexColumn(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    )
        : void {
        if (this.props.column.canHaveChildren()) {
            (this.props.column as MultipleQueryColumn).expand();
        }
        this.props.columnsChanged();
    }

    private onUnexpandComplexColumn(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    )
        : void {
            (this.props.column as MultipleQueryColumn).unexpand();
        this.props.columnsChanged();
    }

    /* TODO: you can drag to any text area on the PC. How do
       we avoid this? */
    // DragEventHandler<HTMLDivElement> | undefined;
    onHeadingDragStart = (ev: React.DragEvent<HTMLDivElement>) => {
        //ev.preventDefault();
        //const id = (ev.target as HTMLDivElement).id;
        ev.dataTransfer.setData(`${RowHeader.DragDataPrefix}${this.props.column.textualId}`, this.props.column.textualId);
    }

    onContextMenu: MouseEventHandler<HTMLDivElement> = (ev) => {
        ev.preventDefault();
        let column = this.props.column;
        this.props.onContextMenu(ev, column);
    }
   
}

function miniButton(
    cssClass: string,
    contents: string,
    action: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)) {
    return (<button onClick={action} className={cssClass}>{contents}</button>);
}